import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import MPageHeader from "../../../../component/PageHeader";
import DocumentTable from "../component/DocumentTable";
import { DocumentUI } from "../entity/document.model";
import { documentService } from "../service/document.service";

function Documents() {
  const [documents, setDocuments] = useState<DocumentUI[]>([]);
  let navigate = useNavigate();

  useEffect(() => {
    documentService.getDocuments().then((_documents) => {
      setDocuments(_documents);
    });
  }, []);

  return (
    <>
      <MPageHeader crumbs={["Документ"]} />

      <div className="content">
        <div className="card">
          <div className="card-header header-elements-inline">
            <h6 className="card-title">Документ</h6>
            <div className="header-elements">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => navigate("/documents/add")}
              >
                <i className="icon-plus2 pr-1"></i>
                Документ нэмэх
              </button>
            </div>
          </div>
          <div className="card-body">
            <DocumentTable documents={documents} />
          </div>
        </div>
      </div>
    </>
  );
}

export default Documents;
